import React from "react";
import { connect } from "react-redux";
import propTypes from "prop-types";
import * as actions from "../../actions";

import "./Nav.css";

const Nav = props => {
  function onClick(event) {
    event.preventDefault();
    props.setUnityAnimation(props.animation);
    props.goToGroup(props.groupID);
  }
  return (
    <button
      className={
        "navItem" +
        (props.navigationWait || props.currentStage !== null ? " hide" : "") +
        (" " + props.class) +
        (props.warn ? " warning" : "")
      }
      style={{ top: `${props.top}%`, left: `${props.left}%` }}
      onClick={e => onClick(e)}
    >
      <span className="navItem__circle"></span>
      <span className={"navItem__label"}>{props.title}</span>
    </button>
  );
};

function mapStateToProps(state, props) {
  return {
    backToParent: state.navigation.backToParent,
    navigationWait: state.navigation.navigationWait,
    currentStage: state.navigation.currentStage,
    currentGroup: state.navigation.currentGroup,
    loaded: !!(
      !props.animation ||
      (state.media.loadedVideos && state.media.loadedVideos[props.animation])
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goToGroup: groupID => {
      dispatch(actions.goToGroup(groupID));
    },
    goToStage: stageID => {
      dispatch(actions.goToStage(stageID));
    },
    setUnityAnimation: animationName => {
      dispatch(actions.setUnityAnimation(animationName));
    }
  };
}

Nav.propTypes = {
  top: propTypes.number.isRequired,
  left: propTypes.number.isRequired,
  warn: propTypes.bool,
  loaded: propTypes.bool.isRequired,
  goToGroup: propTypes.func.isRequired,
  goToStage: propTypes.func.isRequired,
  currentGroup: propTypes.string.isRequired,
  title: propTypes.string.isRequired,
  navigationWait: propTypes.bool.isRequired,
  currentStage: propTypes.number,
  setUnityAnimation: propTypes.func.isRequired,
  class: propTypes.string.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Nav);
